module.exports = __webpack_public_path__ + "static/media/incendie.5f48507e.svg";